import React from 'react';
import { CustomTheme, Stack, useTheme } from '@mui/material';
import { IForm } from './interfaces';

export const Form: React.FC<IForm> = ({
  children,
  id,
  onSubmit,
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (onSubmit) {
      event.stopPropagation();
      onSubmit();
    }
  };

  return (
    <Stack
      id={id}
      sx={{
        '> *': {
          py: '15px',

          '&:not(:last-child)': {
            borderBottom: `1px dotted ${theme.palette.grey[400]}`,
          },
        },
      }}
      component="form"
      onSubmit={handleSubmit}
    >
      {children}
    </Stack>
  );
};
